import { Link, LinkProps } from 'react-router-dom';
import { useState } from 'react';
import { preloadRoute } from '@/utils/routePreloader';

interface PrefetchLinkProps extends LinkProps {
  prefetchImages?: string[];
}

export const PrefetchLink = ({ 
  to, 
  prefetchImages = [], 
  children, 
  ...props 
}: PrefetchLinkProps) => {
  const [prefetched, setPrefetched] = useState(false);

  const handleMouseEnter = () => {
    if (prefetched) return;
    
    // Preload the route chunk (critical for instant navigation)
    const routePath = typeof to === 'string' ? to : to.pathname || '';
    preloadRoute(routePath);
    
    // Prefetch images
    prefetchImages.forEach(imageSrc => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'image';
      link.href = imageSrc;
      document.head.appendChild(link);
    });
    
    setPrefetched(true);
  };

  return (
    <Link 
      to={to} 
      onMouseEnter={handleMouseEnter} 
      {...props}
    >
      {children}
    </Link>
  );
};
